import './style.css';

import { bind } from 'bind-decorator';
import moment from 'moment';
import React from 'react';
import Editable from './controls/editable';
import ReadOnly from './controls/read-only';

interface IProps {
  value: string;
  readOnly: boolean;
  inline: boolean;
  label: string;
  errored: boolean;
  warning: boolean;

  onChange?: (date: string) => void;
}

interface IState {
  date: string;
  time: string;
}

class ClinicalDatetimePicker extends React.Component<IProps, IState> {
  static defaultProps: Partial<IProps> = {
    onChange: () => null
  };

  constructor(props: any) {
    super(props);

    this.state = {
      date: this.props.value,
      time: this.props.value
    };
  }

  render() {
    let control;
    if (this.props.readOnly) {
      const { value } = this.props;
      control = <ReadOnly date={value} time={value} />;
    } else {
      const { date, time } = this.state;
      control = (
        <Editable
          {...this.props}
          date={date}
          time={time}
          onDateChange={this.onDateChange}
          onTimeChange={this.onTimeChange}
        />
      );
    }

    return <span className="bz-datetime-picker">{control}</span>;
  }

  @bind
  private setValue(date: string, time: string) {
    if (date && time) {
      let selectedTime = moment(time);
      let selectedDate = moment(date);

      selectedTime.set({
        day: selectedDate.get('day'),
        date: selectedDate.get('date'),
        month: selectedDate.get('month'),
        year: selectedDate.get('year')
      });

      let formattedDate = moment(selectedTime).format('YYYY-MM-DDTHH:mm:ss');

      this.props.onChange(formattedDate);
    }
  }

  @bind
  private onTimeChange(dateTime: string) {
    let selectedTime = moment(dateTime).toString();
    this.setState({ time: selectedTime });
    this.setValue(this.state.date, selectedTime);
  }

  @bind
  private onDateChange(dateTime: string) {
    let selectedDate = !!dateTime ? moment(dateTime).toString() : dateTime;
    this.setState({ date: selectedDate });
    this.setValue(selectedDate, this.state.time);
  }
}

export default ClinicalDatetimePicker;
